import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function RenewalDetails() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    membershipNumber: '',
    email: '',
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    // TODO: Implement actual membership lookup
    // For demo purposes, we'll simulate finding a membership
    navigate('/renewal/type');
  };

  return (
    <div className="max-w-md mx-auto">
      <h1 className="text-2xl font-bold text-white mb-6">Renew Your Membership</h1>
      <div className="bg-white/5 rounded-lg p-8">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="membership-number" className="block text-gray-300 mb-2">
              Membership Number
            </label>
            <input
              id="membership-number"
              type="text"
              name="membershipNumber"
              value={formData.membershipNumber}
              onChange={handleChange}
              className="w-full p-2 rounded bg-hdlcc-gray border border-hdlcc-gray focus:border-hdlcc-lightBlue focus:outline-none"
              required
              placeholder="e.g., HDL001"
            />
          </div>

          <div>
            <label htmlFor="email-address" className="block text-gray-300 mb-2">
              Email Address
            </label>
            <input
              id="email-address"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-2 rounded bg-hdlcc-gray border border-hdlcc-gray focus:border-hdlcc-lightBlue focus:outline-none"
              required
              placeholder="Enter your registered email"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-hdlcc-lightBlue text-white py-3 px-6 rounded-lg hover:bg-hdlcc-blue transition-colors"
          >
            Continue to Membership Selection
          </button>
        </form>
      </div>
    </div>
  );
}

export default RenewalDetails;
